export const isAdminDomain = false;
